<template>
  <side-base>
    <div class="swrap">
      <div class="shead">
        <!-- <search-filter
            :enableLeft="false"
            :enableDate="false"
            @search="params.name = $event"
            placeholder="请输入课时包名称"
            :enableFilter="false"
            :enableSearch="true"
            :searchIcon="false"
          ></search-filter> -->
      </div>

      <div class="smain">
        <van-loading type="circular" size="20" v-if="loading" class="flex-center" style="height:100%;">加载中...</van-loading>
        <div class="slist">
          <div class="slwrap" v-for="itm in listAll" :key="itm.id">
            <div class="header van-hairline--bottom">
              {{ itm.curriculumName }}
            </div>
            <div
              class="sitem"
              v-for="itm2 of itm.chargeRecordList"
              :key="itm2.id"
              @click="clickHandler(itm, itm2)"
            >
              <div class="l sicon">
                <side-icon-select :checked="ids.includes(itm2.id)" />
              </div>
              <div class="r van-hairline--bottom">
                <div class="rln1">订单编号：{{ itm2.orderNo }}</div>
                <div class="rln1">
                  <span class="f1">可{{config.selectScene==2?'结转':config.selectScene==3?'转出':'退'}}数量：{{ itm2.remainAmount }}{{ itm2.priceUnitName }}</span>
                  <span class="f1">可{{config.selectScene==2?'结转':config.selectScene==3?'转出':'退'}}费用：{{ itm2.couldRefundMoney | formatNumber }}元</span>
                </div>
                <div class="rln1">
                  下单时间：{{ itm2.orderTime | formatDatetime('yyyy-MM-dd hh:mm:ss') }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <van-empty
          v-if="listAll.length === 0 && !loading"
          image="https://cdn01.xiaogj.com/uploads/x3/assets/m/img/tips/empty.png"
          :description="config.emptyTips"
          image-size="128"
          style="margin-top: 20vh"
        >
        </van-empty>
      </div>

      <side-foot
        @cancel="close"
        @confirm="confirm(getRet())"
        :confirmSubText="config.radio ? '' : `(${list.length})`"
      >
        <select-Base
          :show="!config.radio"
          :ids="ids"
          :list="list"
          :isAll="checkAll"
          @clickAllBtn="checkAll = !checkAll"
        >
          <template v-slot:cont="contSlot">
            {{ contSlot.item.curriculumName }}
            <div style="color: var(--g6)">订单编号：{{ contSlot.item.orderNo }}</div>
          </template>
        </select-Base>
      </side-foot>
    </div>
  </side-base>
</template>

<script>
import sideMixin from '@x3/js/side/0_mixin/mixin-select.js';

export default {
  name: 'x3-side-tuifei-class',
  mixins: [sideMixin],
  data() {
    return {
      pageTitle: '选择',
      // 是否正在加载数据
      loading: true,
      mixinConf: {
        deepKeys: ['chargeRecordList'],
      },

      api: this.$api.orderRefundChargeList,
      params: {
        // 校区ids
        campusIds: [],
        // 学员id,
        studentId: '',
        // 课程id
        curriculumId: '',
        // 是否包含欠费 0：不包括 1：包括欠费
        isOwe: 0,
      },
      // 配置项
      config: {
        // 是否单选功能
        radio: false,
        emptyTips: '未找到订单',
        selectScene: 1, // 1退费2结转3转课
      },
    };
  },
  methods: {
    // 数据加载
    async render() {
      let ret = await this.api(this.params);
      this.listAll = ret.data;
      this.total = ret.data.length;
      this.loading = false;
    },
    getItem(itm, itm2) {
      return {
        ...itm2,
        curriculumName: itm.curriculumName,
        priceItemName: itm.priceItemName,
      };
    },
  },
  created() {
    this.render();
  },
};
</script>

<style lang="scss" scoped>
.swrap {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;

  .smain {
    flex: 1;
    overflow: auto;
    .slist {
      padding: 0 calc(var(--gap) * 8);
      .slwrap {
        margin: calc(var(--gap) * 12) 0;

        background-color: var(--white);
        border-radius: var(--radius-sm);
        .header {
          padding: calc(var(--gap) * 12) calc(var(--gap) * 8);
          font-size: var(--fs-md);
          line-height: var(--lh-md);
          color: var(--g8);
          font-weight: bold;
        }
        .sitem {
          display: flex;
          .l.sicon {
            padding-left: calc(var(--gap) * 8);
            padding-right: calc(var(--gap) * 8);
            padding-top: calc(var(--gap) * 10);
          }
          .r {
            flex: 1;
            padding: calc(var(--gap) * 8);
            .rln1 {
              display: flex;
              padding: calc(var(--gap) * 2) 0;
              color: var(--g7);
              font-size: var(--fs-sm);
              line-height: var(--lh-sm);
              .f1 {
                flex: 1;
              }
            }
          }
        }
      }
    }
  }
}
</style>